import React, { FunctionComponent } from 'react';

/**
 * No Results Icon
 */
const NoResultsIcon: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return (
    <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6667 0.666748H3.00004C1.53337 0.666748 0.346707 1.86675 0.346707 3.33341L0.333374 24.6667C0.333374 26.1334 1.52004 27.3334 2.98671 27.3334H19C20.4667 27.3334 21.6667 26.1334 21.6667 24.6667V8.66675L13.6667 0.666748ZM3.00004 3.33341H12.3334L19 10.0001V21.4401L16.5467 18.9867C18.2534 16.4001 17.9734 12.8934 15.6934 10.6134C14.4 9.32008 12.7067 8.66675 11 8.66675C9.29337 8.66675 7.60004 9.32008 6.29337 10.6134C3.69337 13.2134 3.69337 17.4267 6.29337 20.0134C7.58671 21.3067 9.29337 21.9601 11 21.9601C12.28 21.9601 13.56 21.5867 14.6667 20.8534L18.4667 24.6667H3.00004V3.33341ZM11 19.3067C12.0667 19.3067 13.0667 18.8801 13.8134 18.1334C14.5734 17.3867 14.9867 16.3867 14.9867 15.3201C14.9867 14.2534 14.56 13.2534 13.8134 12.5067C13.0667 11.7467 12.0667 11.3334 11 11.3334C9.93337 11.3334 8.93337 11.7467 8.18671 12.5067C7.42671 13.2534 7.01337 14.2534 7.01337 15.3201C7.01337 16.3867 7.44004 17.3867 8.18671 18.1334C8.93337 18.8934 9.93337 19.3067 11 19.3067Z" // eslint-disable-line
        fill="#555555"
      />
    </svg>
  );
};

export default NoResultsIcon;
